function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { memo } from 'react';
import classNames from 'classnames';
import { Draggable } from '@hello-pangea/dnd';
import { vsClose } from '@deephaven/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from "../Button.js";
import ContextActions from "../context-actions/ContextActions.js";
import { Tooltip } from "../popper/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NavTab = /*#__PURE__*/memo(_ref => {
  var tab = _ref.tab,
    onClose = _ref.onClose,
    onSelect = _ref.onSelect,
    isActive = _ref.isActive,
    activeRef = _ref.activeRef,
    index = _ref.index,
    isDraggable = _ref.isDraggable,
    contextActions = _ref.contextActions,
    renderAfterTabContent = _ref.renderAfterTabContent;
  var key = tab.key,
    _tab$isClosable = tab.isClosable,
    isClosable = _tab$isClosable === void 0 ? onClose != null : _tab$isClosable,
    title = tab.title,
    icon = tab.icon;
  var iconElem;
  if (icon != null) {
    iconElem = /*#__PURE__*/React.isValidElement(icon) ? icon : /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: icon
    });
  }
  return /*#__PURE__*/_jsx(Draggable, {
    draggableId: key,
    index: index,
    isDragDisabled: !isDraggable,
    children: (provided, snapshot) => /*#__PURE__*/_jsxs("div", {
      className: "context-menu-wrapper",
      ref: isActive ? activeRef : null,
      children: [/*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
        ref: provided.innerRef
        // eslint-disable-next-line react/jsx-props-no-spreading
      }, provided.draggableProps), provided.dragHandleProps), {}, {
        className: classNames('btn btn-link btn-nav-tab', {
          active: isActive
        }, {
          dragging: snapshot.isDragging
        }),
        "data-testid": "btn-nav-tab-".concat(title),
        role: "tab",
        tabIndex: 0,
        onAuxClick: e => {
          // Middle mouse button was clicked, and no buttons remain pressed
          if (isClosable && e.button === 1 && e.buttons === 0) {
            onClose === null || onClose === void 0 || onClose(key);
          }
        },
        onClick: e => {
          // have to have seperate check onClick for Safari not supporting AuxClick
          if (isClosable && e.button === 1 && e.buttons === 0) {
            onClose === null || onClose === void 0 || onClose(key);
            return;
          }
          // Left mouse button was clicked, and no buttons remain pressed
          if (e.button === 0 && e.buttons === 0) {
            // focus is normally set on mousedown, but dnd calls preventDefault for drag purposes
            // so we can call focus on the firing of the actual click event manually
            e.target.focus();
            onSelect(key);
          }
        },
        onKeyPress: event => {
          if (event.key === 'Enter') onSelect(key);
        },
        children: [iconElem, /*#__PURE__*/_jsxs("span", {
          className: "btn-nav-tab-title",
          children: [title, /*#__PURE__*/_jsx(Tooltip, {
            children: title
          })]
        }), renderAfterTabContent === null || renderAfterTabContent === void 0 ? void 0 : renderAfterTabContent(tab), isClosable && /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-nav-tab-close",
          onClick: event => {
            onClose === null || onClose === void 0 || onClose(key);
            event.stopPropagation();
            event.preventDefault();
          },
          icon: vsClose,
          tooltip: "Close"
        })]
      })), /*#__PURE__*/_jsx(ContextActions, {
        actions: contextActions
      })]
    })
  }, key);
});
NavTab.displayName = 'NavTab';
export default NavTab;
//# sourceMappingURL=NavTab.js.map